package com.klantenstop.web.data.models.dto.responses

import kotlinx.serialization.Serializable

@Serializable
data class ReviewTotalDto(
    val total: Int = 0,
    val average: Double = 0.0
)
